export default theme => ({
  link: {
    fontSize: 12,
  },
  container: {
    marginTop: 10,
    padding: "0px 10px",
  },
  content: {
    marginTop: 15,
    "& .MuiGrid-root": {
      padding: 12,
    },
  },
  button: {
    cursor: "pointer",
  },
});
